import { atom } from "recoil";
const date = new Date();
 const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // الشهر يبدأ من 0، لذا نضيف 1
  const day = String(date.getDate()).padStart(2, '0');
const formattedDate = `${year}-${month}-${day}`;
const backDateState =atom({
    key: 'backDate',
    default: formattedDate
})

export default backDateState